import React, { Component } from 'react'
import { withStyles } from 'material-ui/styles'
import Button from 'material-ui/Button'
import CircularProgress from 'material-ui/Progress/CircularProgress'
import green from 'material-ui/colors/green'
import Input from 'material-ui/Input'
import {SelectWrapped, style as selectStyle} from '../common/SelectWrapped'

const style = theme => ({
  root: {
    flexDirection: 'column'
  },
  wrapper: {
    margin: theme.spacing.unit,
    position: 'relative'
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '20px',
    left: '60px',
    marginTop: -12,
    marginLeft: -12
  },
  ...selectStyle(theme)
})

class AssignDriverForm extends Component {
  constructor (props) {
    super(props)
    this.state = {
      driverHere: {label: props.driver.fullName, value: props.driver}
    }
    this.handleChangeDriver = this.handleChangeDriver.bind(this)
  }

  handleChangeDriver (driverHere) {
    this.setState({
      driverHere
    })
  }

  render () {
    const {
      classes,
      driver,
      onAssign,
      successMsg,
      isJobsRequestOngoing,
      drivers
    } = this.props

    const { driverHere } = this.state

    return <div>
      <form noValidate autoComplete='off' className={classes.root}>
        <Input
          fullWidth
          inputComponent={SelectWrapped}
          inputProps={{
            classes,
            value: driverHere,
            multi: false,
            onChange: this.handleChangeDriver,
            placeholder: 'Assign to a driver',
            instanceId: 'react-select-chip',
            id: 'react-select-chip-driver',
            name: 'react-select-chip',
            simpleValue: false,
            options: drivers.map(driver => ({value: driver, label: driver.fullName}))
          }}
        />

        <div className={classes.wrapper} >
          <Button
            disabled={!driverHere || isJobsRequestOngoing || driverHere.label === driver.fullName}
            color='primary' variant='raised' onClick={() => onAssign(driverHere.value)}>Assign Driver</Button> &nbsp;
          {isJobsRequestOngoing && <CircularProgress size={24} className={classes.buttonProgress} />}
          {!isJobsRequestOngoing && successMsg}
        </div>
      </form>
    </div>
  }
}

AssignDriverForm.defaultProps = {
  driver: null
}

export default withStyles(style)(AssignDriverForm)



// WEBPACK FOOTER //
// ./src/jobs/AssignDriverForm.js